export const CONFIG_MAP = {
  5000: {
    api_url: 'http://93.85.85.58:3002/api',
    logo_name: 'logo.aed13c04.svg',
  },
  5001: {
    api_url: 'http://93.85.85.58:3003/api',
    logo_name: 'domiart.svg',
  },
  5002: {
    api_url: 'http://93.85.85.58:3004/api',
    logo_name: 'domiart.svg',
  },
  5003: {
    api_url: 'http://93.85.85.58:3005/api',
    logo_name: 'domiart.svg',
  },
  5004: {
    api_url: 'http://93.85.85.58:3006/api',
    logo_name: 'domiart.svg',
  },
  5005: {
    api_url: 'http://93.85.85.58:3007/api',
    logo_name: 'domiart.svg',
  },
  5006: {
    api_url: 'http://93.85.85.58:3008/api',
    logo_name: 'logo.divotex.svg',
  },
  5007: {
    api_url: 'http://93.85.85.58:3009/api',
    logo_name: 'domiart.svg',
  },
  5008: {
    api_url: 'http://93.85.85.58:3010/api',
    logo_name: 'domiart.svg',
  },
  5009: {
    api_url: 'http://93.85.85.58:3011/api',
    logo_name: 'domiart.svg',
  },
  5010: {
    api_url: 'http://93.85.85.58:3012/api',
    logo_name: 'domiart.svg',
  },
};

function getConfig() {
  const { port } = window.location;
  if (port) {
    return CONFIG_MAP[port];
  }
  const finalObject = {
    api_url: 'http://93.85.85.58:3012/api',
    logo_name: 'domiart.svg',
  }
  const { host } = window.location;
  const [first, second, third] = host.split('.');
  const digit = first.replace(/^\D+/g, '');
  finalObject.api_url = `https://api${digit}.${second}.${third}/api`
  if (second === 'k-domiart') {
    finalObject.logo_name = 'domiart.svg'
  } else if (second === 'belkraft') {
    finalObject.logo_name = 'logo.aed13c04.svg'
  } else if (second === 'k-divotex') {
    finalObject.logo_name = 'logo.divotex.svg'
    finalObject.api_url = `https://api${digit}.${second}.${third}.ua/api`
  }
  return finalObject;
}

export function getLogoName() {
  const config = getConfig();
  if (config) {
    return config.logo_name;
  }
  return 'logo.aed13c04.svg';
}

export function getApiUrl() {
  const config = getConfig();
  if (config) {
    return config.api_url;
  }
  return process.env.REACT_APP_URL_API;
}



// WEBPACK FOOTER //
// ./src/utils/config.ts